module.exports = __webpack_public_path__ + "img/schema_verticalisateur_6a.8481e803.svg";